import { Flex, Spinner, Text } from "@chakra-ui/react";
import { useGetFormTemplateSettings } from "src/generated/hooks/form-service/queries";
import { useTimezoneName } from "src/hooks/useOrganization";
import { useFormTemplateContext } from "../formTemplateContext";
import { EditFormTemplateSettingsProvider } from "./context";
import { SettingsForm } from "./SettingsForm";
import { toInitialValues } from "./utils";

export const SettingsTab: React.FC = () => {
  const { formTemplate } = useFormTemplateContext();

  const id = formTemplate.id;
  const timezoneName = useTimezoneName();

  const {
    data: settingsResponse,
    isLoading,
    isError,
  } = useGetFormTemplateSettings({
    path: { formTemplateId: id },
  });

  const settings = settingsResponse?.data;

  if (isLoading) {
    return (
      <Flex justify="center" align="center" py={8}>
        <Spinner />
      </Flex>
    );
  }

  if (isError || !settings) {
    return (
      <Flex justify="center" align="center" py={8}>
        <Text color="red.500">Failed to load form template settings.</Text>
      </Flex>
    );
  }

  const initialValues = toInitialValues(settings, timezoneName);

  return (
    <EditFormTemplateSettingsProvider
      settingsInitialValues={initialValues}
      formTemplateId={settings.id}
    >
      <SettingsForm isLoading={isLoading} />
    </EditFormTemplateSettingsProvider>
  );
};
